/**
 * @desc 查询某个场次的报名记录
 */
import {
  ApplyEntity,
  TradeSessionApplyOperationListParam
} from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryTradeSessionApplyListParameter =
  TradeSessionApplyOperationListParam

const method = 'GET'
const url = '/trade/operation/apply/tradeSession'

export const queryTradeSessionApplyListApi = (
  params?: QueryTradeSessionApplyListParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<ApplyEntity>>({
    method,
    url,
    params,
    ...config
  })
}

queryTradeSessionApplyListApi.method = method
queryTradeSessionApplyListApi.url = url
